import React from "react";
import ListsPage from "./ListsPage";
import { TRANSPORTATION_TYPES } from "../utils/railwayOrder";

const RailwayOrdersListPage = () => <ListsPage transportationType={TRANSPORTATION_TYPES.RAILWAY} />;

export default RailwayOrdersListPage;
